import Image from 'next/image';
import { FC } from 'react';

import spinnerImage from '@/assets/images/spinner.svg';
import spinnerWhiteImage from '@/assets/images/spinner_white.svg';
import classNames from '@/helpers/classNames';

import styles from './Spinner.module.scss';

interface SpinnerProps {
  className?: string;
  spinnerClassName?: string;
  size?: number;
  color?: 'white' | 'blue';
}

const Spinner: FC<SpinnerProps> = (props: SpinnerProps) => (
  <div className={classNames([styles.wrapper, props.className])}>
    <Image
      src={props.color === 'white' ? spinnerWhiteImage : spinnerImage}
      alt=""
      width={props.size || 24}
      height={props.size || 24}
      className={classNames([styles.spinner, props.spinnerClassName])}
    />
  </div>
);
export default Spinner;
